import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
  palette: {
    type: 'light',

    // Override main colors here (Buttons, etc.)
    primary: {
      light: '#9d73ff', // light purple
      main: '#6948ff', // purple (default MUI theme "error" color)
      dark: '#4e43ff', // dark purple
      gradient:
        'linear-gradient(32deg, rgba(78,67,255,1) 0%, rgba(105,72,255,1) 26%, rgba(157,115,255,1) 100%)',
    },

    // secondary: {
    //   main: '#55B89F', // green turqoise
    //   light: '#E8CC8D', // beige
    // },
  },

  typography: {
    // Set global fonts here
    // https://material-ui.com/customization/typography/#font-family

    // Default font
    fontFamily: ['Open Sans', 'sans-serif'].join(','),

    // Title fonts
    h1: {
      fontSize: '2rem',
    },

    h2: {
      fontSize: '1.75rem',
    },

    h3: {
      fontSize: '1.5rem',
    },

    h4: {
      fontSize: '1.25rem',
    },

    h5: {
      fontSize: '1rem',
    },
  },
})

export default theme
